<template>
  <div>
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 213 128">
      <defs>
        <clipPath id="clippath">
          <rect class="letak-cls-13" x="-39.11" y="-28.74" width="282.21" height="178.13"/>
        </clipPath>
        <clipPath id="clippath-1">
          <rect class="letak-cls-13" x="-39.11" y="-28.74" width="282.21" height="178.13"/>
        </clipPath>
        <clipPath id="clippath-2">
          <path class="letak-cls-13" d="M15.48,127.25h0s0,0,0,0M1.23,23.96c-1.04.16-.78,1.01-.78,1.01l15.03,102.28s-.11-.89,1.16-1.09c10.21-1.61,57.6-7.93,80.89-19.67,0,0-23.19-103.28-24.25-105.84C47.2,16.46,9.42,22.74,1.23,23.96"/>
        </clipPath>
        <linearGradient id="linear-gradient" x1="-37.32" y1="1062.54" x2="-36.32" y2="1062.54" gradientTransform="translate(3406.19 96944.73) scale(91.18 -91.18)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#fff"/>
          <stop offset=".3" stop-color="#fbfbfb"/>
          <stop offset=".59" stop-color="#efeff0"/>
          <stop offset=".88" stop-color="#dbdcdd"/>
          <stop offset="1" stop-color="#d1d3d4"/>
        </linearGradient>
        <clipPath id="clippath-3">
          <rect class="letak-cls-13" x="-39.11" y="-28.74" width="282.21" height="178.13"/>
        </clipPath>
        <clipPath id="clippath-4">
          <rect class="letak-cls-13" x="-7.36" y="15.84" width="34.38" height="111.24"/>
        </clipPath>
        <filter id="luminosity-noclip" x="-15.11" y="13.45" width="49.86" height="116.02" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood flood-color="#fff" result="bg"/>
          <feBlend in="SourceGraphic" in2="bg"/>
        </filter>
        <linearGradient id="linear-gradient-2" x1="-30.97" y1="1160.48" x2="-29.97" y2="1160.48" gradientTransform="translate(277.85 10280.06) scale(8.8 -8.8)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#fff"/>
          <stop offset="1" stop-color="#000"/>
        </linearGradient>
        <mask id="mask" x="-15.11" y="13.45" width="49.86" height="116.02" maskUnits="userSpaceOnUse">
          <g class="letak-cls-35">
            <rect class="letak-cls-3" x="-11.2" y="14.77" width="42.05" height="113.36" transform="translate(-4.96 .86) rotate(-4)"/>
          </g>
        </mask>
        <clipPath id="clippath-5">
          <rect class="letak-cls-13" x="-7.36" y="15.84" width="34.38" height="111.24"/>
        </clipPath>
      </defs>
      <g class="letak-cls-31">
        <polygon class="letak-cls-12" points="67.2 26.29 72.27 98.8 212.89 88.96 190.87 54.07 207.82 16.46 67.2 26.29"/>
        <text class="letak-cls-6" transform="translate(99.92 45.94) rotate(-4)"><tspan class="letak-cls-24" x="0" y="0">V</tspan><tspan class="letak-cls-22" x="11.3" y="0">E</tspan><tspan x="21.26" y="0">Č </tspan><tspan class="letak-cls-19" x="36.69" y="0">K</tspan><tspan class="letak-cls-4" x="47.66" y="0">O</tspan><tspan x="60.93" y="0">T</tspan></text>
        <text class="letak-cls-8" transform="translate(101.47 68.07) rotate(-4)">{{ props.stevilo_izdelkov }}</text>
        <text class="letak-cls-6" transform="translate(102.67 85.29) rotate(-4)"><tspan class="letak-cls-25" x="0" y="0">I</tspan><tspan class="letak-cls-32" x="5.49" y="0">Z</tspan><tspan class="letak-cls-27" x="14.67" y="0">DE</tspan><tspan class="letak-cls-34" x="37.19" y="0">L</tspan><tspan class="letak-cls-19" x="45.73" y="0">K</tspan><tspan class="letak-cls-5" x="56.71" y="0">O</tspan><tspan x="69.74" y="0">V</tspan></text>
        <g class="letak-cls-16">
          <path class="letak-cls-17" d="M15.47,127.11c.13.9,1.21.82,2.36.75,15.89-1.02,66.49-8.04,77.5-13.9l-14.43-104.91L5.09,24.7l10.38,102.41Z"/>
          <path class="letak-cls-33" d="M15.47,127.11c11.31-.51,68.82-9.61,80.4-16.31L77.79,6.46,2.57,24.75l12.9,102.36Z"/>
        </g>
        <g class="letak-cls-23">
          <rect class="letak-cls-28" x="-4.11" y="-2.59" width="105.94" height="133.08" transform="translate(-4.34 3.56) rotate(-4)"/>
        </g>
        <g class="letak-cls-20">
          <g class="letak-cls-21">
            <g class="letak-cls-2">
              <g class="letak-cls-11">
                <g class="letak-cls-18">
                  <path class="letak-cls-7" d="M2.48,25.04c-1.11.18,2.64,23.7,6.56,47.7,3.92,24,7.57,52.19,8.55,52.12.98-.07-.69-11.86-7.03-52.47C4.21,31.78,3.59,24.86,2.48,25.04"/>
                </g>
              </g>
            </g>
          </g>
          <path class="letak-cls-12" d="M55.76,47.85c-1.11,3.3-3.59,4.95-5.69,5.46-1.44.35-3.03-.4-3.43-2.14l-.56-2.41,8.57-1.98c-4.61-3.14-11.38-10.16-14.28-15.34-.35,5.94-3.36,15.21-5.99,20.02l8.44-1.95.58,2.41c.3,1.38-.46,3.05-2.06,3.4-2.21.48-5.2.1-7.52-2.35-1.69-1.78-2.95-3.21-3.7-6.47-1.64-7.12,2.73-14.35,10.03-16.04,7.22-1.67,14.44,3.06,16.04,10.02.75,3.26-.12,6.43-.43,7.36M39.39,27.22c-9.16,2.11-14.6,11.03-12.52,20.05,1.35,5.86,5.51,10.42,11.3,11.79,5.44,1.28,11.95-.22,16.29-3.76,4.28-3.49,6.32-9.69,4.97-15.55-2.07-8.96-10.93-14.63-20.04-12.53"/>
          <text class="letak-cls-9" transform="translate(32.84 87.56) rotate(-13) skewX(-4)"><tspan class="letak-cls-26" x="0" y="0">N</tspan><tspan class="letak-cls-30" x="13.25" y="0">O</tspan><tspan x="26.33" y="0">V</tspan></text>
          <text class="letak-cls-9" transform="translate(29.4 103.53) rotate(-13) skewX(-4)"><tspan class="letak-cls-29" x="0" y="0">L</tspan><tspan class="letak-cls-14" x="8.56" y="0">E</tspan><tspan class="letak-cls-10" x="18.72" y="0">T</tspan><tspan class="letak-cls-26" x="26.64" y="0">A</tspan><tspan x="37.97" y="0">K</tspan></text>
        </g>
      </g>
    </svg>
  </div>
</template>

<script setup>
const props = defineProps(["stevilo_izdelkov"]);
</script>

<style>
  .letak-cls-1 {
    letter-spacing: 0em;
  }

  .letak-cls-2 {
    clip-path: url(#clippath-4);
  }

  .letak-cls-3 {
    fill: url(#linear-gradient-2);
  }

  .letak-cls-4 {
    letter-spacing: -.02em;
  }

  .letak-cls-5 {
    letter-spacing: -.03em;
  }

  .letak-cls-6 {
    font-size: 17.26px;
  }

  .letak-cls-6, .letak-cls-7, .letak-cls-8 {
    fill: #fff;
  }

  .letak-cls-6, .letak-cls-9, .letak-cls-8 {
    font-family: GilroyBold, 'GilroyBold';
    font-weight: 400;
  }

  .letak-cls-10 {
    letter-spacing: -.05em;
  }

  .letak-cls-11 {
    mask: url(#mask);
  }

  .letak-cls-12 {
    fill: #00a651;
  }

  .letak-cls-13 {
    fill: none;
  }

  .letak-cls-14 {
    letter-spacing: 0em;
  }

  .letak-cls-15 {
    letter-spacing: 0em;
  }

  .letak-cls-16 {
    clip-path: url(#clippath-1);
  }

  .letak-cls-17 {
    fill: #bcbec0;
  }

  .letak-cls-18 {
    clip-path: url(#clippath-5);
  }

  .letak-cls-19 {
    letter-spacing: -.04em;
  }

  .letak-cls-20 {
    clip-path: url(#clippath-3);
  }

  .letak-cls-21 {
    opacity: .3;
  }

  .letak-cls-22 {
    letter-spacing: 0em;
  }

  .letak-cls-23 {
    clip-path: url(#clippath-2);
  }

  .letak-cls-24 {
    letter-spacing: 0em;
  }

  .letak-cls-25 {
    letter-spacing: -.01em;
  }

  .letak-cls-26 {
    letter-spacing: 0em;
  }

  .letak-cls-27 {
    letter-spacing: 0em;
  }

  .letak-cls-9 {
    fill: #ed1c24;
    font-size: 17.3px;
  }

  .letak-cls-28 {
    fill: url(#linear-gradient);
  }

  .letak-cls-29 {
    letter-spacing: -.02em;
  }

  .letak-cls-30 {
    letter-spacing: -.03em;
  }

  .letak-cls-31 {
    clip-path: url(#clippath);
  }

  .letak-cls-32 {
    letter-spacing: 0em;
  }

  .letak-cls-33 {
    fill: #d1d3d4;
  }

  .letak-cls-8 {
    font-size: 24.65px;
  }

  .letak-cls-34 {
    letter-spacing: -.02em;
  }

  .letak-cls-35 {
    filter: url(#luminosity-noclip);
  }
</style>